import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeVariant } from '@robocorp/components';
import { IconLoading } from '@robocorp/icons/animated';
import {
  IconStatusCompleted,
  IconStatusError,
  IconStatusNew,
  IconStatusPending,
  IconType,
} from '@robocorp/icons';
import { Color } from '@robocorp/theme';
import { WorkItemState } from '@robocorp/robocloud-orchestrator-interface';

interface Props {
  state: WorkItemState;
}

const variants: Record<
  WorkItemState,
  {
    variant: BadgeVariant;
    icon: IconType;
    iconColor: Color;
  }
> = {
  [WorkItemState.New]: {
    variant: 'primary',
    icon: IconStatusNew,
    iconColor: 'content.subtle',
  },
  [WorkItemState.Registered]: {
    variant: 'primary',
    icon: IconStatusNew,
    iconColor: 'content.subtle',
  },
  [WorkItemState.Pending]: {
    variant: 'primary',
    icon: IconStatusPending,
    iconColor: 'content.subtle',
  },
  [WorkItemState.InProgress]: {
    variant: 'primary',
    icon: IconLoading,
    iconColor: 'content.subtle',
  },
  [WorkItemState.Failed]: {
    variant: 'danger',
    icon: IconStatusError,
    iconColor: 'background.error',
  },
  [WorkItemState.Completed]: {
    variant: 'success',
    icon: IconStatusCompleted,
    iconColor: 'background.success',
  },
  [WorkItemState.Output]: {
    variant: 'primary',
    icon: IconStatusNew,
    iconColor: 'content.subtle',
  },
};

const WorkItemAvatar = forwardRef<HTMLDivElement, Props>(({ state }, forwardedRef) => {
  const { t } = useTranslation();
  const label = t(`workItemState.${state}`) || '';
  const { icon, variant, iconColor } = variants[state];
  return (
    <Badge icon={icon} iconColor={iconColor} variant={variant} label={label} ref={forwardedRef} />
  );
});

export default WorkItemAvatar;
